import React, { useEffect, useState } from "react";
import axios from "../../axiosConfig";
import "../../styles/inputs-Css/RequestAccess.css";

const AccessRequestsTable = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRequests = async () => {
    try {
      const res = await axios.get("/books/book-control/requests", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setRequests(res.data);
    } catch (err) {
      console.error("Failed to fetch access requests", err);
      alert("Error loading access requests.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleApprove = async (user_id, book_id) => {
    try {
      await axios.post(
        "/books/book-control/approve",
        { user_id, book_id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("Access approved!");
      fetchRequests();
    } catch (err) {
      console.error("Error approving access", err);
      alert("Failed to approve access.");
    }
  };

  const handleDeny = async (user_id, book_id) => {
    try {
      await axios.post(
        "/books/book-control/deny",
        { user_id, book_id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("Access denied.");
      fetchRequests();
    } catch (err) {
      console.error("Error denying access", err);
      alert("Failed to deny access.");
    }
  };

  return (
    <div className="access-requests-container">
      <div className="page-head">
        <div>
          <h1 className="page-title">Request Access</h1>
          <p className="page-desc">
            Incoming access requests from readers waiting on a book.
          </p>
        </div>
      </div>

      <div className="panel">
        {loading ? (
          <div className="empty-note">Loading…</div>
        ) : requests.length === 0 ? (
          <div className="empty-note">No pending requests right now.</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Book Title</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Requested At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((req, index) => (
                  <tr key={`${req.user_id}-${req.book_id}-${index}`}>
                    <td className="cell-title" style={{ color: "var(--primary-ink)" }}>
                      {req.book_title}
                    </td>
                    <td>{req.user_name || "N/A"}</td>
                    <td>{req.email}</td>
                    <td>
                      {req.created_at
                        ? new Date(req.created_at).toLocaleString()
                        : "N/A"}
                    </td>
                    <td>
                      <div className="row-actions">
                        <button
                          type="button"
                          className="mini-btn"
                          onClick={() => handleApprove(req.user_id, req.book_id)}
                        >
                          Approve
                        </button>
                        <button
                          type="button"
                          className="mini-btn danger"
                          onClick={() => handleDeny(req.user_id, req.book_id)}
                        >
                          Deny
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccessRequestsTable;
